import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import {
  AlertMessage,
  Button,
  CardWrapper,
  CoreLoader,
  DownloadIcon,
  GroupInput,
  Input,
  Label,
} from "common/components";
import { AddExperienceModal } from ".";
import apiManager from "networking/baseAPIManager";
import { documentFormSchema } from "utils/formValidationUtils";
import "../../../../assets/style/Responsive.css";

const ExperienceDetails = () => {
  let paramsData = useParams();
  let empid = paramsData.empid;

  const [modalShow, setModalShow] = useState(false);
  const [extraExperienceData, setExtraExperienceData] = useState([]);
  const [experience, setExperience] = useState({});
  const [loading, setLoading] = useState(false);
  const [allApiData, setAllApiData] = useState({});

  const [showMSG, setShowMSG] = useState(false);
  const [msgType, setmsgType] = useState("info");

  const forminitialValue = {
    companyname: experience?.companyname || "",
    start_date: experience?.start_date || "",
    end_date: experience?.end_date || "",
    payslip: experience?.payslip || null,
    offerletter: experience?.offerletter || null,
    relievingletter: experience?.relievingletter || null,
    resignationletter: experience?.resignationletter || null,
    compensation: experience?.compensation || null,
    experienceletter: experience?.experienceletter || null,
  };

  const navigate = useNavigate();
  const { handleChange, handleBlur, handleSubmit, values, touched, errors, setFieldValue } = useFormik({
    initialValues: forminitialValue,
    validationSchema: documentFormSchema,
    onSubmit: (values, action) => {
      handleDocsSubmit(values);
    },
    enableReinitialize: true,
  });

  const getcandidateDocuments = () => {
    setLoading(true);
    apiManager
      .candidateDocuments(empid)
      .then((res) => {
        setLoading(false);
        setExtraExperienceData(structuredClone(res?.data?.data?.extraExperienceData));
        setExperience({ ...res?.data?.data?.experienceData });
        setAllApiData(structuredClone(res?.data));
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };

  useEffect(() => {
    empid && getcandidateDocuments();
  }, [empid]);

  const handleDocsSubmit = (data) => {
    const formData = new FormData();
    formData.append("empid", empid);
    formData.append("companyname", data.companyname);
    formData.append("end_date", data.end_date);
    formData.append("start_date", data.start_date);

    extraExperienceData?.length &&
      extraExperienceData.map((item, index) => {
        Object.keys(item).map((key) => {
          if (typeof item[key] == "object") {
            formData.append([key], item[key]);
          }
        });
      });

    formData.append("compensation", data.compensation);
    formData.append("experienceletter", data.experienceletter);
    formData.append("offerletter", data.offerletter);
    formData.append("payslip", data.payslip);
    formData.append("relievingletter", data.relievingletter);
    formData.append("resignationletter", data.resignationletter);
    if (extraExperienceData?.length) {
      formData.append("extraExperience", JSON.stringify(extraExperienceData));
    }

    setLoading(true);
    apiManager
      .addEmployeeDocuments(formData)
      .then((response) => {
        setLoading(false);
        setShowMSG("Details updated");
        setmsgType("success");
        navigate(`/hrtools/employee-onboarding/candidatePreview/${empid}`);
      })
      .catch((error) => {
        setLoading(false);
        setShowMSG("failed to update Details");
        setmsgType("error");
        console.log(error);
      });
  };

  const renderFileInput = (name, label) => {
    if (values[name] && typeof values[name] == "string") {
      const downloadAttachment = async () => {
        let BASE_URL = process.env.REACT_APP_BASE_URL;
        const attachmentData = `${BASE_URL}/${values[name]}`;

        if (!attachmentData) {
          console.error("No attachment data found.");
          return;
        }

        try {
          const response = await fetch(attachmentData);
          const blob = await response.blob();
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", values[name]);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        } catch (error) {
          console.error("Error fetching or triggering download:", error);
        }
      };
      return (
        <div className=" row pt-3">
          <div className="col-lg-5 col-xl-4 align-items-center"> {label} </div>
          <div className="col-lg-3 d-flex align-items-center">
            <Button onClick={() => downloadAttachment()} label="Download" type="button" />
            {allApiData?.data?.status == "pending" ? (
              <span
                className="material-symbols-outlined pointer"
                onClick={() => {
                  setFieldValue([name], undefined);
                }}
              >
                edit
              </span>
            ) : (
              ""
            )}
          </div>
        </div>
      );
    }

    return (
      <>
        <div className="row pt-3 align-items-center">
          <Label label={label || "Upload Result"} required parentclasses="col-xl-4  col-lg-5 col-md-6" />
          <Input
            type="file"
            parentclasses="col-xl-8 col-lg-12 col-md-12"
            accept="image/*, .pdf"
            name={name}
            onChange={(e) => {
              setFieldValue(name, e.target.files[0]);
            }}
            onBlur={handleBlur}
            isValid={touched[name] && !errors[name]}
            touched={touched[name]}
            error={errors[name]}
          />
        </div>
      </>
    );
  };

  const renderFileInputloop = (index, key, label) => {
    let item = extraExperienceData[index];
    let image = item[key];
    console.log(image, "image");
    let labels = {
      offerletter: "Offer Letter",
      payslip: "Pay slip",
      relievingletter: "Relieving Letter",
      experienceletter: "Experience Letter",
      resignationletter: "Resignation Letter",
      compensation: "Compensation",
    };

    let labelKey = key;
    if (labels[key]) {
      labelKey = labels[key];
    }
    const downloadAttachment = async () => {
      let BASE_URL = process.env.REACT_APP_BASE_URL;
      const attachmentData = `${BASE_URL}/${image}`;

      if (!attachmentData) {
        console.error("No attachment data found.");
        return;
      }

      try {
        const response = await fetch(attachmentData);
        const blob = await response.blob();
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", image);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      } catch (error) {
        console.error("Error fetching or triggering download:", error);
      }
    };
    if (image) {
      return (
        <div className="w-100 d-flex gap-3 align-items-center mt-2">
          <div className="capitalize w-50 normalBold d-flex align-items-center"> {labelKey} </div>

          <Button onClick={() => downloadAttachment()} label="Download" type="button" />
          {allApiData?.data?.status == "pending" ? (
            <span
              className="material-symbols-outlined pointer"
              onClick={() => {
                extraExperienceData[index][key] = undefined;
                setExtraExperienceData([...extraExperienceData]);
              }}
            >
              edit
            </span>
          ) : (
            ""
          )}
        </div>
      );
    }

    return (
      <>
        <div className="d-flex align-items-center gap-4 py-3">
          <Label label={label || "Upload Result"} required parentclasses="col-xl-3 col-lg-4" />
          <Input
            type="file"
            parentclasses="col-xl-8 co-lg-7"
            accept="image/*, .pdf"
            name={extraExperienceData[index]}
            required
            onChange={(e) => {
              extraExperienceData[index][key] = e.target.files[0];
              setExtraExperienceData([...extraExperienceData]);
            }}
            onBlur={handleBlur}
            isValid={touched[extraExperienceData[index]] && !errors[extraExperienceData[index]]}
            touched={touched[extraExperienceData[index]]}
            error={errors[extraExperienceData[index]]}
          />
        </div>
      </>
    );
  };

  const rendermultiFields = () => {
    if (!extraExperienceData || !Array.isArray(extraExperienceData)) {
      return <></>;
    }
    return (
      <>
        {extraExperienceData.map((item, index) => {
          let { companyname, start_date, end_date } = item;

          return (
            <div key={index} className="align-items-center normalCard">
              <div className="d-flex w-100 align-items-end justify-content-end">
                <span
                  className="material-symbols-outlined pointer"
                  onClick={() => {
                    extraExperienceData.splice(index, 1);
                    setExtraExperienceData([...extraExperienceData]);
                  }}
                >
                  close
                </span>
              </div>
              <div className=" col-xl-12 d-flex align-items-center  pb-2">
                <Label label="Company Name" parentclasses="col-xl-1 col-lg-2" />
                <Input
                  parentclasses="col-xl-10 col-lg-8 col-md-6 ms-5 ps-5"
                  placeholder="Company Name"
                  value={companyname || ""}
                  onChange={(e) => {
                    extraExperienceData[index].companyname = e.target.value;
                    setExtraExperienceData([...extraExperienceData]);
                  }}
                />
              </div>
              <div className="">
                <div className="d-flex align-items-center gap-5 py-4">
                  <Label label="Start Date" parentclasses="col-xl-3 col-lg-4 col-md-5" />
                  <GroupInput
                    name="start_date"
                    parentclasses="col-xl-8 col-lg-7 col-md-6"
                    type="date"
                    value={start_date || ""}
                    onChange={(e) => {
                      extraExperienceData[index].start_date = e.target.value;
                      setExtraExperienceData([...extraExperienceData]);
                    }}
                    onBlur={handleBlur}
                    isValid={touched.start_date && !errors.start_date}
                    touched={touched.start_date}
                    error={errors.start_date}
                  />
                </div>
                <div className="d-flex align-items-center gap-5 py-4">
                  <Label label="End Date" parentclasses="col-xl-3 col-lg-4 col-md-5" />
                  <Input
                    parentclasses="col-xl-8 col-lg-7 col-md-6"
                    name="end_date"
                    type="date"
                    label="End Date"
                    value={end_date || ""}
                    onChange={(e) => {
                      extraExperienceData[index].end_date = e.target.value;
                      setExtraExperienceData([...extraExperienceData]);
                    }}
                    onBlur={handleBlur}
                    isValid={touched.end_date && !errors.end_date}
                    touched={touched.end_date}
                    error={errors.end_date}
                  />
                </div>
                {renderFileInputloop(index, "payslip")}
                {renderFileInputloop(index, "offerletter")}
                {renderFileInputloop(index, "relievingletter")}
                {renderFileInputloop(index, "resignationletter")}
                {renderFileInputloop(index, "compensation")}
                {renderFileInputloop(index, "experienceletter")}
              </div>
            </div>
          );
        })}
      </>
    );
  };

  return (
    <>
      <AlertMessage show={showMSG} setShow={setShowMSG} type={msgType} />

      <div className="gap-3 text-center subheaderbackgroundoffWhite p-2 d-flex align-items-center justify-content-center">
        <h2>Candidate Experience Details </h2>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="px-4 py-4 container  ">
          <div className="row pb-3 align-items-center">
            <Label label="Company Name" parentclasses="col-xl-3 col-lg-4 col-md-5" />
            <Input
              type="text"
              parentclasses="col-xl-8 col-lg-8 col-md-7 "
              name="companyname"
              value={values.companyname || ""}
              onChange={handleChange}
              onBlur={handleBlur}
              isValid={touched.companyname && !errors.companyname}
              touched={touched.companyname}
              error={errors.companyname}
            />
          </div>
          <div className="row  align-items-center ">
            <Label label="Start Date" parentclasses="col-xl-2 col-lg-2  col-md-5 topadding" />
            <Input
              parentclasses="col-xl-4  col-lg-4 col-md-7 topadding"
              name="start_date"
              type="date"
              value={values.start_date || ""}
              onChange={handleChange}
              onBlur={handleBlur}
              isValid={touched.start_date && !errors.start_date}
              touched={touched.start_date}
              error={errors.start_date}
            />

            <Label label="End Date" parentclasses="col-xl-2 col-lg-2  col-md-5  topadding " />
            <Input
              parentclasses="col-xl-4 col-lg-4  col-md-7 topadding"
              name="end_date"
              type="date"
              value={values.end_date || ""}
              onChange={handleChange}
              onBlur={handleBlur}
              isValid={touched.end_date && !errors.end_date}
              touched={touched.end_date}
              error={errors.end_date}
            />
          </div>

          <div className="row align-items-center">
            <div className=" col-xl-6 col-lg-6  col-md-6 col-sm-6"> {renderFileInput("payslip", "Payslip")}</div>

            <div className=" col-xl-6 col-lg-6  col-md-6 col-sm-6">
              {renderFileInput("offerletter", "Offer letter")}
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-xl-6 col-lg-6  col-md-6 ">{renderFileInput("relievingletter", "Relieving letter")}</div>
            <div className="col-xl-6 col-lg-6  col-md-6 ">
              {renderFileInput("resignationletter", "Resignation letter")}
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-xl-6 col-lg-6  col-md-6  "> {renderFileInput("compensation", "Compensation")}</div>
            <div className="col-xl-6 col-lg-6  col-md-6">
              {renderFileInput("experienceletter", "Experience letter")}{" "}
            </div>
          </div>
        </div>

        {rendermultiFields()}
        <div className="d-flex gap-3 justify-content-end px-4">
          <Button
            type="button"
            label="Add Experience"
            onClick={() => {
              setModalShow(!modalShow);
            }}
          />
        </div>

        {modalShow && (
          <div className="mt-3">
            <AddExperienceModal
              show={modalShow}
              setShow={setModalShow}
              data={extraExperienceData}
              setData={setExtraExperienceData}
            />
          </div>
        )}

        <div
          className=" button-container 
         d-flex gap-3 justify-content-end subheaderbackground p-2 px-4 mt-3"
        >
          <Button
            classes="responsiver-button"
            type="button"
            label="Back"
            onClick={() => navigate(`/hrtools/employee-onboarding/educationdetails/${empid}`)}
          />
          <Button
            type="submit"
            label="Save & Continue"
            classes="responsiver-button btn-outline-dark bg-light text-primary"
          />
          {allApiData?.nextPage ? (
            <Button
              classes="responsiver-button"
              type="button"
              label="Next"
              onClick={() => navigate(`/hrtools/employee-onboarding/candidatePreview/${empid}`)}
            />
          ) : (
            ""
          )}
        </div>
      </form>
      <CoreLoader show={loading} disableLines />
    </>
  );
};

export default ExperienceDetails;
